import { TaskStatus } from '@nexelem/graphne-api';

export const startedStatuses: TaskStatus[] = [TaskStatus.InProgress, TaskStatus.Completed];
